import { EgretLoadable } from "egret";
import { authRoles } from "../../auth/authRoles";

const PendingAchProcessing = EgretLoadable({
  loader: () => import("./pending_ach_processing")
});

const PendingApproval = EgretLoadable({
  loader: () => import("./pending_approval")
});

const AchInProcess = EgretLoadable({
  loader: () => import("./ach_in_process")
});

const Returns = EgretLoadable({
  loader: () => import("./returns")
});

const ResidualProcessing = EgretLoadable({
  loader: () => import("./residual_processing")
});

const ResidualReport = EgretLoadable({
  loader: () => import("./ResidualReport")
});

const IncomeByStateReport = EgretLoadable({
  loader: () => import("./IncomeByStateReport")
});

const billingRoutes = [
  {
    path: "/billing/pending/ach",
    component: PendingAchProcessing,
    auth: authRoles.billing
  },
  {
    path: "/billing/pending/approval",
    component: PendingApproval,
    auth: authRoles.billing
  },
  {
    path: "/billing/ach/processing",
    component: AchInProcess,
    auth: authRoles.billing
  },
  {
    path: "/billing/ach/returns",
    component: Returns,
    auth: authRoles.billing
  },
  {
    path: "/billing/residual/processing",
    component: ResidualProcessing,
    auth: authRoles.billing
  },
  {
    path: "/billing/residual/report",
    component: ResidualReport,
    auth: authRoles.reseller
  },
  {
    path: "/billing/income/state/report",
    component: IncomeByStateReport,
    auth: authRoles.billing
  }

];

export default billingRoutes;
